/*!
 * Beagle v1.5.2
 * https://foxythemes.net
 *
 * Copyright (c) 2018 Foxy Themes
 */

var App = (function () {
  'use strict';

  App.dataTables = function( ){

    //We use this to apply style to certain elements
    $.fn.DataTable.ext.pager.numbers_length = 7;
    $.extend( true, $.fn.dataTable.defaults, {
      dom:
        "<'datatable-panel'<'datatable-panel__left'><'datatable-panel__right'<'input-group input-search datatable-panel__search'f>>>" +
        "<'row be-datatable-body'<'col-sm-12'tr>>" +
        "<'row be-datatable-footer'<'col-sm-2'l><'col-sm-4'i><'col-sm-6'p>>"
    } );

    initTableWithCustomSearchInput();

    $('.datatable-with-sort').dataTable({
      paging:   false,
      ordering: true,
      info:     false,
      order:    [],
      dom:  "<'row be-datatable-body'<'col-sm-12'tr>>"
    });

    //Remove search & paging dropdown
    $(".datatable-simple").dataTable({
      pageLength: 6,
      dom:  "<'row be-datatable-body'<'col-sm-12'tr>>" +
            "<'row be-datatable-footer'<'col-sm-5'i><'col-sm-7'p>>"
    });

    function initTableWithCustomSearchInput() {
      var tableSelector = ".datatable-with-search";
      var tables = $(tableSelector).dataTable({
        order: [],
        language: {
          searchPlaceholder: "Поиск"
        }
      });

      var searchIconHtml = '<span class="input-group-btn"><button class="btn btn-secondary"><i class="icon mdi mdi-search"></i></button></span>';
      var defaultSearchInputSelector = '.datatable-panel .dataTables_filter input[type=search]';
      $(defaultSearchInputSelector).after(searchIconHtml);
    }

  };

  return App;
})(App || {});
